import JDashboardLayoutBuilder from './JDashboardLayoutBuilder.vue'
import JPageLayoutBuilderSvg from './JPageLayoutBuilderSvg.vue'

// It must be exported with default to be the global component
// on the plugin feature.
export default {
  JDashboardLayoutBuilder,
  JPageLayoutBuilderSvg,
}
